<template>
    <view-card title="연락처">
        <v-row v-if="isAuthorized" slot="title-actions">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <view-contact-modify v-model="expert" @input="sync" />
            </v-col>
        </v-row>
        <data-list :dataList="dataList" />
    </view-card>
</template>

<script>
import DataList from "./data-list.vue";
import ViewCard from "./view-card.vue";
import ViewContactModify from "./view-contact-modify.vue";

export default {
    components: {
        DataList,
        ViewCard,
        ViewContactModify,
    },
    props: {
        value: Object,
    },
    data() {
        return {
            expert: {},
        };
    },
    computed: {
        payload() {
            return this.$store.state?.payload || {};
        },
        isUser() {
            return this.value?._id == this.payload?._user;
        },
        isConsole() {
            return (this.payload?.scope || [])?.includes("console");
        },
        isAuthorized() {
            return this.isUser || this.isConsole;
        },
        isContactDisplayed() {
            return this.value?.isContactDisplayed ?? false;
        },
        dataList() {
            const { phone, email } = this.value;

            if (this.isContactDisplayed)
                return [
                    { term: "전화번호", description: phone?.phoneNumberFormat() || "-", cols: 6 },
                    { term: "이메일", description: email || "-", cols: 6 },
                ];
            else return [];
        },
    },
    methods: {
        init() {
            this.expert = { ...this.value };
        },
        sync() {
            this.$emit("input", this.expert);
            // this.$nextTick(() => this.init());
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>

<style></style>
